function toElements(value) {
    if (!value) return [];

    if (Array.isArray(value)) {
        return value.filter(Boolean);
    }

    if (value instanceof Element) {
        return [value];
    }

    if (value instanceof NodeList || value instanceof HTMLCollection) {
        return Array.from(value).filter(Boolean);
    }

    return [];
}

function getNavigationElements(swiper) {
    const navigation = swiper?.navigation || {};
    const params = swiper?.params?.navigation || {};

    return {
        prev: toElements(navigation.prevEl).concat(toElements(params.prevEl)),
        next: toElements(navigation.nextEl).concat(toElements(params.nextEl)),
    };
}

function isUnavailable(button, direction, swiper) {
    const disabledClass = swiper?.params?.navigation?.disabledClass || 'swiper-button-disabled';

    return button.classList.contains(disabledClass) ||
        button.classList.contains('swiper-button-disabled') ||
        (direction === 'prev' && swiper?.isBeginning) ||
        (direction === 'next' && swiper?.isEnd);
}

function syncButton(button, unavailable) {
    button.disabled = unavailable;
    button.tabIndex = unavailable ? -1 : 0;
    button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
}

export function syncSwiperNavigationA11y(swiper) {
    if (!swiper || !swiper.params?.navigation) return swiper;

    const elements = getNavigationElements(swiper);

    elements.prev.forEach(button => syncButton(button, isUnavailable(button, 'prev', swiper)));
    elements.next.forEach(button => syncButton(button, isUnavailable(button, 'next', swiper)));

    return swiper;
}

export function bindSwiperNavigationA11y(swiper) {
    if (!swiper?.on) return swiper;

    const sync = () => requestAnimationFrame(() => syncSwiperNavigationA11y(swiper));

    [
        'afterInit',
        'init',
        'slideChange',
        'transitionEnd',
        'reachBeginning',
        'reachEnd',
        'fromEdge',
        'resize',
        'observerUpdate',
        'navigationUpdate',
        'breakpoint',
    ].forEach(eventName => swiper.on(eventName, sync));

    syncSwiperNavigationA11y(swiper);
    sync();

    return swiper;
}
